import "./svg/ten-percent.svg"

export default {
    name: "ten-percent",
    viewBox: "57 33",
}
